import React, { Component } from 'react'
import Ecell from '../Image/Ecell.png'
export class Student_form_content extends Component {
  render() {
    return (
    <>
    {/* -------------------Mobile View----------------------- */}
    <div className=''>
    <div className='d-sm-block d-md-none mt-5'>
        <div className='fst-normal'>
            <div className='container-fluid'>
            <div className='row'>
                <div className='col-sm-12'>
                <h4 className='text-center pt-4 Student_text-color'>InternsElitein Collaboration With E-Cell IIT Hyderabad and MNC'S | National Level Training & Internship Program. (Enrollment Form)
                </h4></div>
                <div className='col-sm-12'>
                <img className='Mobile_Ecell_logo' src={Ecell} alt='Ecell'></img>
                </div>
            </div>
            </div>
            <br></br>
            <br></br>
            <p className='font-style-all-text px-2'>Hello <span className='fw-bold'>Future Aspirants! 🥇</span></p>
            <p className='font-style-all-text px-2'>
                We at <span className='fw-bold'>InternsElite 🎓</span> warmly welcome you to our<span className='fw-bold'> vibrant community! </span>We're excited to share with you the complete details about our program that can help you take the next big step towards success.<br></br><br></br><span className='fw-bold'>InternsElite 🎓</span> is the place where you can unlock your true potential and rule the world with Elite. Our comprehensive Training+Internship+Placement program is designed to bridge the gap between academia and the industry, ensuring you're equipped with the right skills and knowledge to take on the corporate world.<br></br><br></br>Join our community ⏱️of passionate learners and skilled professionals to explore an array of traineeships and advanced programs such as Machine Learning, Cybersecurity, Digital Marketing, Java, Full stack web development, and more! We have experts with over 10+ years of experience leading the practical-based Industrial Training, helping you gain hands-on experience and live-time industrial projects that'll elevate your profile and make you stand out from the crowd.<br></br><br></br>So, what are you waiting for? Join InternsElite 🎓 today, and let's unlock your true potential together!
            </p>
        </div>

        <div className='fst-normal'>
        <h5 className='text-decoration-underline fs-6'>Benefits Of Joining This Internship:</h5>
        <ul className='mt-3 font-style-all-text'>
            <li className='list-unstyled fw-bold'>✅Pre-placement offer from our partnered companies</li>
            <li className='list-unstyled fw-bold'>✅Helps to Upskill yourself</li>
            <li className='list-unstyled fw-bold'>✅Enhance Your Employability</li>
            <li className='list-unstyled fw-bold'>✅Discover Where You Want to Go</li>
            <li className='list-unstyled fw-bold'>✅Take Advantage of Flexibility </li>
            <li className='list-unstyled '>✅<span className='fw-bold'>LOR (Letter of Recommendation)</span>for Job and internship opportunities.</li>
            <li className='list-unstyled '>✅<span className='fw-bold'>Resume building and Interview</span> preparation sessions.</li>
            <li className='list-unstyled fw-bold'>✅Paid internships in MNC's on based on interviews and projects.</li>
        </ul>
        </div>


        <div className='mt-4 border-top border-bottom border-danger py-3 fst-normal student_page_text'>
        <h5 className='fst-normal text-center px-2'>KINDLY DO READ DESCRIPTION AND DETAILS PROPERLY BEFORE FILING THE FORM.CLEAR <br></br> YOUR DOUBTS AND QUERIES ON CALL WITH EXECUTIVE.</h5>
        </div>

        <div className='my-3'>
        <div className='Student_opacity rounded font-style-all-text'>
         <h6 className='text-center text-dark fw-bold p-2'>
         FILL THE FORM FOR A CALL BACK REQUEST<br></br>(Internship details, curriculum, will be sent to you upon request)
         </h6>   
        </div>

      </div>
    </div>
    </div>

    {/* ----------------------Desktop View------------------------- */}
    <div className='d-none d-md-block mt-5'>
    <div className='fst-normal'>
        <div className='container'>
        <div className='row'>
            <div className='col-lg-9'>
            <h4 className='text-center pt-4 Student_text-color'>InternsElite in Collaboration With E-Cell IIT Hyderabad and MNC'S | National Level Training & Internship Program. (Enrollment Form)
            </h4></div>
            <div className='col-lg-3'>
            <img className='Ecell_logo mt-4' src={Ecell} alt='Ecell'></img>
            </div>
        </div>
        </div>
        <br></br>
        <p className='font-style-all-text'>Hello <span className='fw-bold'>Future Aspirants! 🥇</span></p>
        <p className='font-style-all-text'>
            We at <span className='fw-bold'>InternsElite 🎓</span> warmly welcome you to our<span className='fw-bold'> vibrant community! </span>We're excited to share with you the complete details about our program that can help you take the next big step towards success.<br></br><br></br><span className='fw-bold'>InternsElite 🎓</span> is the place where you can unlock your true potential and rule the world with Elite. Our comprehensive Training+Internship+Placement program is designed to bridge the gap between academia and the industry, ensuring you're equipped with the right skills and knowledge to take on the corporate world.<br></br><br></br>Join our community ⏱️of passionate learners and skilled professionals to explore an array of traineeships and advanced programs such as Machine Learning, Cybersecurity, Digital Marketing, Java, Full stack web development, and more! We have experts with over 10+ years of experience leading the practical-based Industrial Training, helping you gain hands-on experience and live-time industrial projects that'll elevate your profile and make you stand out from the crowd.<br></br><br></br>So, what are you waiting for? Join InternsElite 🎓 today, and let's unlock your true potential together!
        </p>
    </div>

    <div className='fst-normal'>
    <h4 className='text-decoration-underline'>Benefits Of Joining This Internship:</h4>
    <ul className='mt-3 font-style-all-text' >
        <li className='list-unstyled fw-bold'>✅Pre-placement offer from our partnered companies</li>
        <li className='list-unstyled fw-bold'>✅Helps to Upskill yourself</li>
        <li className='list-unstyled fw-bold'>✅Enhance Your Employability</li>
        <li className='list-unstyled fw-bold'>✅Discover Where You Want to Go</li>
        <li className='list-unstyled fw-bold'>✅Take Advantage of Flexibility </li>
        <li className='list-unstyled '>✅<span className='fw-bold'>LOR (Letter of Recommendation)</span>for Job and internship opportunities.</li>
        <li className='list-unstyled '>✅<span className='fw-bold'>Resume building and Interview</span> preparation sessions.</li>
        <li className='list-unstyled fw-bold'>✅Paid internships in MNC's on based on interviews and projects.</li>
    </ul>
    </div>


    <div className='mt-3 border-top border-bottom border-danger py-3 fst-normal student_page_text'>
    <h5 className='fst-normal '>KINDLY DO READ DESCRIPTION AND DETAILS PROPERLY BEFORE FILING THE FORM.CLEAR <br></br> YOUR DOUBTS AND QUERIES ON CALL WITH EXECUTIVE.</h5>
    </div>

    <div className='my-3 '>
    <div className='Student_opacity rounded font-style-all-text p-2'>
    <h6 className='text-center text-dark fw-bold p-2'>
    FILL THE FORM FOR A CALL BACK REQUEST<br></br>(Internship details, curriculum, will be sent to you upon request)
    </h6>   
    </div>

    </div>
    </div>
    </>
    )
  }
}

export default Student_form_content
